jQuery(document).ready(function ($) {
    const $lightbox = $('#experience-lightbox');

    if (!$lightbox.length) return;

    const $title = $lightbox.find('[data-experience-lightbox-title]');
    const $subtitle = $lightbox.find('[data-experience-lightbox-subtitle]');
    const $description = $lightbox.find('[data-experience-lightbox-description]');
    const $gallery = $lightbox.find('[data-experience-lightbox-gallery]');
    const $gallery_wrapper = $lightbox.find('[data-experience-lightbox-gallery-wrapper]');
    const $current = $lightbox.find('.experience-lightbox__gallery--counter .current');
    const $total = $lightbox.find('.experience-lightbox__gallery--counter .total');
    const $usps = $lightbox.find('[data-experience-lightbox-usps]');
    const $prices = $lightbox.find('[data-experience-lightbox-prices]');
    const $price_standard = $lightbox.find('[data-experience-lightbox-price-standard]');
    const $price_bide_club_row = $lightbox.find('[data-experience-lightbox-price-bide-club-row]');
    const $price_bide_club = $lightbox.find('[data-experience-lightbox-price-bide-club]');

    let lightbox_swiper = null;

    function update_counter(swiper) {
        const slide_number = swiper.realIndex + 1;
        $current.text(String(slide_number).padStart(2, '0'));
    }

    function open_lightbox($trigger) {
        const title = $trigger.attr('data-experience-lightbox-title') || '';
        const subtitle = $trigger.attr('data-experience-lightbox-subtitle') || '';
        const description = $trigger.attr('data-experience-lightbox-description') || '';

        const urls = (($trigger.attr('data-experience-lightbox-gallery') || ''))
            .split(',')
            .map(function (url) { return url.trim(); })
            .filter(Boolean);

        $title.text(title);
        $subtitle.text(subtitle).prop('hidden', !subtitle);
        $description.text(description).prop('hidden', !description);

        const usps = (($trigger.attr('data-experience-lightbox-usps') || ''))
            .split('|')
            .map(function (usp) { return usp.trim(); })
            .filter(Boolean);

        $usps.empty();

        usps.forEach(function (usp) {
            $usps.append($('<span>', { class: 'experience-lightbox__usp', text: usp }));
        });

        $usps.prop('hidden', !usps.length);

        const price_standard = $trigger.attr('data-experience-lightbox-price-standard') || '';
        const price_bide_club = $trigger.attr('data-experience-lightbox-price-bide-club') || '';

        $price_standard.text(price_standard ? '£' + price_standard : '');
        $price_bide_club.text(price_bide_club ? '£' + price_bide_club : '');
        $price_bide_club_row.prop('hidden', !price_bide_club);
        $prices.prop('hidden', !price_standard);

        if (lightbox_swiper) {
            lightbox_swiper.destroy(true, true);
            lightbox_swiper = null;
        }

        $gallery_wrapper.empty();

        urls.forEach(function (url) {
            $gallery_wrapper.append(
                $('<div>', { class: 'experience-lightbox__gallery--image swiper-slide' }).append(
                    $('<img>', { src: url, alt: '' })
                )
            );
        });

        $gallery.prop('hidden', !urls.length);

        $lightbox.addClass('is-open').attr('aria-hidden', false);
        $('body').addClass('experience-lightbox-open');

        if (urls.length) {
            $total.text(' / ' + String(urls.length).padStart(2, '0'));

            lightbox_swiper = new Swiper('#experience-lightbox-gallery', {
                loop: urls.length > 1,
                slidesPerView: 1,
                slidesPerGroup: 1,
                grabCursor: true,
                spaceBetween: 24,
                observer: true,
                observeParents: true,
                navigation: {
                    prevEl: '.experience-lightbox__gallery--prev',
                    nextEl: '.experience-lightbox__gallery--next'
                },
                on: {
                    init: update_counter,
                    slideChange: update_counter
                }
            });
        }
    }

    function close_lightbox() {
        $lightbox.removeClass('is-open').attr('aria-hidden', true);
        $('body').removeClass('experience-lightbox-open');
    }

    $(document).on('click', '[data-experience-lightbox-toggle]', function (event) {
        event.preventDefault();
        open_lightbox($(this));
    });

    $(document).on('click', '.js-experience-lightbox-close', function (event) {
        event.preventDefault();
        close_lightbox();
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $lightbox.hasClass('is-open')) {
            close_lightbox();
        }
    });
});
